module.exports = __webpack_public_path__ + "img/index-security-right.51dae33b.png";